// import 'moment';
import moment from 'moment';
import React from 'react';
import DatePicker, { DateObject } from "react-multi-date-picker"
import DatePanel from 'react-multi-date-picker/plugins/date_panel';


const RandomDatePicker = (props) => {
  const datePickerRef = React.useRef()
  const [shouldClose, setShouldClose] = React.useState(false)
  const [selectedDate, setSelectedDate] = React.useState([new Date()]);

  React.useEffect(()=>{
    setSelectedDate([new Date()])
    const dateList = [{
      startDate: moment().startOf('day').toDate().valueOf(),
      endDate: moment().endOf('day').toDate().valueOf(),
    }]
    props.handleChange(dateList)
  },[])

  React.useEffect(()=>{
    if(shouldClose){
      datePickerRef.current.closeCalendar();
      setShouldClose(false)
    }
  },[shouldClose])

  const handleClickClose = (e) => {
    setShouldClose(true)
    const dateList = selectedDate.map(item=>{
      const date = new DateObject(item).format("MM/DD/YYYY")
      return {
        startDate: moment(date).startOf('day').toDate().valueOf(),
        endDate: moment(date).endOf('day').toDate().valueOf(),
      }
    })
    return props.handleChange(dateList);
  }

  return (
    <React.Fragment>
      <DatePicker 
        multiple
        sort
        value={selectedDate} 
        onClose={() => shouldClose}
        onChange={setSelectedDate}
        ref={datePickerRef} 
        placeholder="Select date..."
        style={{height: "38px"}}
        minDate={new Date('04/11/2021')}
        maxDate={new Date()}
        plugins={[
          <DatePanel />
        ]}
      >
        <div className="m-3 d-flex justify-content-end">
          <p onClick={handleClickClose} className="primary pointer m-0">
            Close
          </p>
        </div>
      </DatePicker>
    <style jsx="true">{`
      .datepicker > div{
        height: 38px;
        color: ${props?.color}
      }
    `}</style>
    </React.Fragment>
  );
}

export default RandomDatePicker;